const serviceUrlPro = 'https://task.xiaowuxiongdi.com/api'
const serviceUrlUat = 'http://studio.xiaowukeji.cn/api'
const buildDev = '/api'

// const serviceUrlDev = 'http://47.56.181.187:8091'

// const serviceUrlDev = 'http://172.16.26.10:8091'

// const serviceUrlDev = 'http://172.16.26.189:8091'

// const serviceUrlDev = 'http://172.16.26.163:8091'

// const serviceUrlDev = 'http://172.16.25.105:8091' // dy
// const serviceUrlDev = 'http://172.16.25.10:8091' // dy本地

// const serviceUrlDev = 'http://172.16.24.200:8097' // cs

// const serviceUrlDev = 'http://172.16.26.127:8091' // dd

// const serviceUrlDev = 'http://172.16.25.179:8091' // 新测试
// const serviceUrlDev = 'http://172.16.24.200:8097' // cs
// const serviceUrlTest = 'http://172.16.24.200:8097' // cs
// const serviceUrlTest = 'http://172.16.25.179:8091' // cs新的
// const serviceUrlDev = 'http://172.16.25.94:8080' // 自得
const serviceUrlDev = 'http://172.16.24.200:8097' // cs
// const serviceUrlDev = 'http://172.16.25.191:8080' // wc
// const serviceUrlDev = 'http://172.16.25.45:8091' // dy
const serviceUrlTest = 'http://172.16.24.200:8097' // cs
// const managerApiServiceUrlDev = 'http://172.16.25.45:8080/' // dy

// const serviceUrlDev = 'http://172.16.25.41:8091'
// const serviceUrlDev = 'http://172.16.25.45:8091'

// const serviceUrl = 'http://172.16.26.225:8091' // 旧cs
// const managerApiServiceUrlDev = 'http://172.16.25.94:8080' // 自德
// const managerApiServiceUrlDev = 'http://172.16.25.10:8080' // dy
// const managerApiServiceUrlDev = 'http://172.16.25.41:8092/managerApi'
const managerApiServiceUrlDev = 'http://172.16.24.200:8092'
// const managerApiServiceUrlDev = 'http://172.16.25.45:8080' // dy
const amsServiceUrlDev = 'http://172.16.24.200:8023' // ams

const newOperationTest = 'http://api.test.xiaowutw.com/dispatcher/' // 新运营
const newOperationOPro = ' https://apisea.xiaowuxiongdi.com/dispatcher/' // 新运营

const projectConfiguration = {
  managerApi: process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'buildTest' ? managerApiServiceUrlDev : '/newStudio', // silverdawn-operation-server  运营系统
  ams: process.env.NODE_ENV === 'development' ? amsServiceUrlDev : '/ams', // ams
  newOperation: ['development', 'buildTest'].includes(process.env.NODE_ENV) ? newOperationTest : newOperationOPro,
}

// 运营系统转发丽链接
const longCutShortVideoServiceUrlDev = 'http://172.16.24.200:8092/ope'

// const longCutShortVideoServiceUrlDev = 'http://172.16.25.185:8061' // 用于跟运营后端(徐广鹏)本地联调

// 老运营系统转发标识配置
const operationServiceUrlConfig = {
  longCutShortVideo: process.env.NODE_ENV === 'development' ? longCutShortVideoServiceUrlDev : '/ope',
}

const envServiceUrlMap = {
  development: serviceUrlDev,
  production: serviceUrlPro,
  buildTest: serviceUrlTest,
  buildUat: serviceUrlUat,
  buildDev,
}

// console.log(process.env.NODE_ENV)
const serviceUrl = envServiceUrlMap[process.env.NODE_ENV]

// 版本信息，更新版本后使用户刷新浏览器以更新缓存
const version = '78'
const oldVersion = '68'

export default {
  serviceUrl,

  // Endpoints
  loginEndpoint: `${serviceUrl}/sso/doLoginByTicket`,
  userInfoEndpoint: `${serviceUrl}/sso/userInfo`,
  isLoginEndpoint: `${serviceUrl}/sso/isLogin`,
  ssoAuthUrlEndpoint: `${serviceUrl}/sso/getSsoAuthUrl`,
  logoutEndpoint: `${serviceUrl}/sso/logout`,

  routeEndpoint: `${serviceUrl}/base/route`,
  menuEndpoint: `${serviceUrl}/base/menu`,

  // routeEndpoint: '/base/route',
  // menuEndpoint: '/base/menu',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
  storageVersionKeyName: 'version',
  version,
  operationServiceUrlConfig,
  projectConfiguration,
}
